module.exports = __webpack_public_path__ + "static/media/explorer_100.fa139f69.ico";